module.exports = __webpack_public_path__ + "img/1.faab82ac.png";